import { Heading, VStack, Input, Button, Box, Table, Thead, Tbody, Tr, Th, Td, Select, useToast, Checkbox, Text, useColorModeValue, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Collapse, HStack } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tooltip } from "@chakra-ui/react";
import { jwtDecode } from "jwt-decode";
import { format } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { Exam } from '../../../Platform/Common/types';
import { FiTrash, FiEdit } from "react-icons/fi";
import { fmtLocal } from '../../../utils/dates';
import { useTenant } from '../../../Platform/Routers/TenantContextProvider';

interface Tenant {
  tenant_id: number;
  name: string;
  description: string;
  is_active: boolean;
}

// Define the expected structure of the token payload
interface TokenPayload {
  sub: string;       // Typically the username or user ID
  role_id: number;   // Role ID
  tenant_id: number; // Tenant ID
  exp?: number;      // Expiration timestamp (optional)
}

const B2CExamManager = () => {
  const [exams, setExams] = useState<Exam[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<number | null>(null);
  const navigate = useNavigate();

  const toast = useToast();
  const tableHeaderbg = useColorModeValue("gray.200", "gray.700");

  const { tenant, loading, error } = useTenant();

  // Function to get tenant_id from the token
  const getTenantIdFromToken = (token: string): number | null => {
    try {
      const decoded: TokenPayload = jwtDecode<TokenPayload>(token);
      return decoded.tenant_id || null;
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };

  // Set tenant ID on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const tenantId = getTenantIdFromToken(token);
      console.log("Tenant ID:", tenantId);
      setSelectedTenant(tenantId);
    }
  }, []);

  // Fetch exams when tenant ID is set
  useEffect(() => {
    if (selectedTenant) {
      fetchExams();
    }
  }, [selectedTenant]);

  const fetchExams = async () => {
    if (!selectedTenant) return;
    try {
      const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || 'https://default-url.com';
      const response = await axios.get(`${tenantsapiurl}/${selectedTenant}/exams`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setExams(response.data);
    } catch (error) {
      console.error("Failed to load exams", error);
    }
  };

  const handleReviewExam = (exam_id: number) => {

      navigate(`/practice/app/assessment-manager/review-assessment/${exam_id}`);
  };


  const handleAddNewExam = () => {
    const exam_id=0;
       navigate(`/practice/app/assessment-manager/review-assessment/${exam_id}`);
  };

    const handleDeleteExam = async (exam_id: number) => {
      // Placeholder function
         try {
           const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
         console.log("Printing Token from Delete" + localStorage.getItem("token"));
         await axios.delete(apiurl + `/delete-exam/${exam_id}`, {
           headers: {
             Authorization: `Bearer ${localStorage.getItem('token')}`
           }
         });
         fetchExams();
         toast({ title: "Exam deleted successfully", status: "success" });
       } catch (error) {
         console.error("Failed to delete Exam", error);
         toast({ title: "Failed to delete Exam", status: "error" });
       }
     
    };
  

  return (
    <Box as="main" mx="auto" p={10} >
      <VStack>
        <Heading size={"md"}>Exams</Heading>
      </VStack>
      <Box mt={4}>
        <Text fontWeight="bold">Exam Details</Text>
        <Button mt={2} borderRadius={"sm"} fontSize="sm" fontWeight="normal" onClick={handleAddNewExam}>
          + Exam
        </Button>
      </Box>
      <Box mt={4}>

        <Table mt={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
          <Thead fontSize="12">
            <Tr bgColor={tableHeaderbg}>
              <Th>ID</Th>
              <Th>Title</Th>
              <Th>Status</Th>
              <Th>Published At</Th>
              <Th>Start Time</Th>
              <Th>End Time</Th>
              {/* <Th>Updated At</Th> */}
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody fontSize="12">
            {exams.map((exam) => (
              <Tr key={exam.exam_id}>
                <Td>{exam.exam_id}</Td>
                <Td>{`${exam.title}`}</Td>
                <Td>{`${exam.status.replace(/_/g, " ")}`}</Td>

                    <Td>
                      {exam.published_at ? fmtLocal(exam.published_at, { hour: undefined, minute: undefined }) : 'N/A'}
                    </Td>

                <Td>{fmtLocal(exam.start_time)}</Td>
                <Td>{fmtLocal(exam.end_time)}</Td>
             
                <Td>
                  <Tooltip label="Edit">
                    <Button size="sm" onClick={() => handleReviewExam(exam.exam_id)}  mr={8}>
                        <FiEdit />
                    </Button>
                    <Button
                      size="sm"
                      colorScheme="red"
                      onClick={() => {
                      if (window.confirm("Are you sure you want to delete this Exam?")) {
                        handleDeleteExam(exam.exam_id);
                      }
                      }}
                  >
                      <FiTrash />
                        </Button>
                  </Tooltip>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

    </Box>
  );
};

export default B2CExamManager;
